import Splide from "@splidejs/splide";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";

const mvSlide = () => {
  const elm = document.querySelector(".p-home__mv-slide .splide");

  new Splide(elm, {
    type: "fade",
    autoplay: true,
    rewind: true,
  }).mount();

  const elm2 = document.querySelector(".p-home__visual .splide");

  const visualSplide = new Splide(elm2, {
    type: "loop",
    autoWidth: true,
    arrows: false,
    pagination: false,
    gap: 8,
    drag: false,

    autoScroll: {
      speed: 0.8,
      pauseOnFocus: false,
      pauseOnHover: false,
    },
    breakpoints: {
      768: {
        focus: "center",
      },
    },
  }).mount({ AutoScroll });

  // AutoScrollのトグル制御
  const toggleButton = document.querySelector(".p-home__visual-controls .splide__toggle");
  if (toggleButton) {
    let isPlaying = true;

    toggleButton.addEventListener("click", () => {
      const autoScroll = visualSplide.Components.AutoScroll;

      if (isPlaying) {
        autoScroll.pause();
        toggleButton.classList.add("is-paused");
      } else {
        autoScroll.play();
        toggleButton.classList.remove("is-paused");
      }

      isPlaying = !isPlaying;
    });
  }
};

const initializeTop = () => {
  mvSlide();
};
document.addEventListener("DOMContentLoaded", event => {
  initializeTop();
});
